import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

/**
 *
 * @param className 使用class选择器例如 '.className' .必不可少
 * @param setLoading 可选设置按钮的状态
 */
export  const generatePdf = async (className:string, setLoading?: (loading: boolean) => void) => {
  setLoading?.(true);
  try {
    // 1. 获取所有要转换为 PDF 的页面元素
    const pages = document.querySelectorAll<HTMLElement>(className); // 使用class选择器例如 '.className' .必不可少
    if (pages.length === 0) {
      console.warn('No pages found to convert to PDF.');
      setLoading?.(false);
      return;
    }

    // 2. 创建 jsPDF 实例，明确设置为 A4 大小，单位为 mm
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF({
      unit: 'mm',
      format: 'a4', // A4 大小为 210mm x 297mm
    });

    // 也可以手动指定尺寸，例如：
    // const pdf = new jsPDF({
    //   unit: 'mm',
    //   format: [210, 297],
    // });

    // 3. 获取 PDF 的宽高（单位：mm）
    const pageWidth = pdf.internal.pageSize.getWidth();

    // 4. 遍历所有需要转换的页面
    for (let i = 0; i < pages.length; i++) {
      const page = pages[i];

      // 使用 html2canvas 将每个页面转换为 Canvas
      const canvas = await html2canvas(page, {
        scale: 2, // 提升分辨率
        useCORS: true,
      });

      // 5. Canvas 转换为图片数据
      const imgData = canvas.toDataURL('image/png');

      // 计算图片放到 PDF 中后的实际高度
      const imgWidth = pageWidth; // 宽度占满整张 A4 宽度
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // 不是第 0 个（第一页）就添加新页
      if (i > 0) {
        pdf.addPage();
      }

      // 将图片添加到 PDF 中 (x=0, y=0)
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    }

    // 6. 下载 PDF
    pdf.save('download.pdf');
  } catch (error) {
    console.error('Error generating PDF:', error);
  } finally {
    setLoading?.(false);
  }
};
